import { apiConfig } from '../api-config';

export const getPixTxId = async (cdTerritory: string, tokenKey: string) => {
  return apiConfig
    .get(`/api/Payment/get-pix-by-territory?cdTerritory=${cdTerritory}&tokenKey=${tokenKey}`)
    .then((resp) => resp.data.objectResult || [])
    .catch((err) => ({ hasErrors: true, err }));
};
